var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJaEvent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13865_92536)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 4.06543C15.5077 4.06582 20.0088 8.56736 20.0088 14.0752C20.0084 14.7958 19.4237 15.3797 18.7031 15.3799H15.4395C15.2452 15.3799 15.0612 15.3359 14.8955 15.2598C14.7298 15.336 14.5459 15.3798 14.3516 15.3799H11.7402C11.0195 15.3798 10.435 14.7958 10.4346 14.0752C10.4346 13.8391 10.2361 13.6401 10 13.6396C9.76363 13.6396 9.56445 13.8388 9.56445 14.0752C9.56402 14.7958 8.97941 15.3797 8.25879 15.3799H5.64746C5.45318 15.3798 5.26919 15.3359 5.10352 15.2598C4.93785 15.3359 4.75384 15.3798 4.55957 15.3799H1.2959C0.575128 15.3799 -0.00933087 14.7959 -0.00976562 14.0752C-0.00976562 8.56712 4.49192 4.06543 10 4.06543ZM10 5.37109C5.21296 5.37109 1.2959 9.28816 1.2959 14.0752H4.55957C4.55957 11.203 6.84373 8.63477 10 8.63477L10.293 8.64258C13.2962 8.79611 15.4395 11.2929 15.4395 14.0752H18.7031C18.7031 9.43773 15.0272 5.61704 10.4453 5.38281L10 5.37109ZM10 9.72266C7.26384 9.72266 5.64746 11.6382 5.64746 14.0752H8.25879C8.25879 13.1178 9.04259 12.334 10 12.334L10.1768 12.3428C11.0516 12.4324 11.7402 13.1777 11.7402 14.0752H14.3516C14.3516 11.7145 12.835 9.84333 10.2529 9.72852L10 9.72266Z",
    fill: "#333333"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13865_92536"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJaEvent);
export default __webpack_public_path__ + "static/media/ja-event.a3e594dd5b7c4ccb9c98466698a444f8.svg";
export { ForwardRef as ReactComponent };